import { Application } from '@hotwired/stimulus';
import ShareController from 'controllers/products/courses/certificate/share_controller';

import 'apps/courses/certificates/style.scss';

window.Stimulus = Application.start();
window.Stimulus.register('courses-certificate-share', ShareController);
